export const POSTS_PER_PAGE = 9
export const SUBSCRIBE_FORM_ID = '124257c0-2401-47c5-99a9-a807a5a603e5'
